import { render, staticRenderFns } from "./SuppliersTable.vue?vue&type=template&id=1b008f7d"
import script from "./SuppliersTable.vue?vue&type=script&lang=js"
export * from "./SuppliersTable.vue?vue&type=script&lang=js"
import style0 from "./SuppliersTable.vue?vue&type=style&index=0&id=1b008f7d&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports